import _objectSpread from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames"; // import styles from "./styles"

var cleanups = {
  // some useless stuff for us
  // that svgo doesn't remove
  title: /<title>.*<\/title>/gi,
  desc: /<desc>.*<\/desc>/gi,
  comment: /<!--.*-->/gi,
  defs: /<defs>.*<\/defs>/gi,
  // remove hardcoded dimensions
  width: / +width="\d+(\.\d+)?(px)?"/gi,
  height: / +height="\d+(\.\d+)?(px)?"/gi,
  // remove fill
  fill: / +fill="(none|#[0-9a-f]+)"/gi,
  // Sketch.app shit
  sketchMSShapeGroup: / +sketch:type="MSShapeGroup"/gi,
  sketchMSPage: / +sketch:type="MSPage"/gi,
  sketchMSLayerGroup: / +sketch:type="MSLayerGroup"/gi
}; // @styled(styles)

var SVGInline =
/*#__PURE__*/
function (_Component) {
  _inherits(SVGInline, _Component);

  function SVGInline() {
    _classCallCheck(this, SVGInline);

    return _possibleConstructorReturn(this, _getPrototypeOf(SVGInline).apply(this, arguments));
  }

  _createClass(SVGInline, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          component = _this$props.component,
          svg = _this$props.svg,
          fill = _this$props.fill,
          width = _this$props.width,
          accessibilityLabel = _this$props.accessibilityLabel,
          accessibilityDesc = _this$props.accessibilityDesc,
          classSuffix = _this$props.classSuffix,
          cleanupExceptions = _this$props.cleanupExceptions,
          componentProps = _objectWithoutProperties(_this$props, ["className", "component", "svg", "fill", "width", "accessibilityLabel", "accessibilityDesc", "classSuffix", "cleanupExceptions"]);

      var _this$props2 = this.props,
          cleanup = _this$props2.cleanup,
          height = _this$props2.height;

      if ( // simple way to enable entire cleanup
      cleanup === true || // passing cleanupExceptions enable cleanup as well
      cleanup.length === 0 && cleanupExceptions.length > 0) {
        cleanup = Object.keys(cleanups);
      }

      cleanup = cleanup.filter(function (key) {
        return !(cleanupExceptions.indexOf(key) > -1);
      });

      if (width && height === undefined) {
        height = width;
      } // remove useless props for wrapper


      delete componentProps.cleanup;
      delete componentProps.height;
      var classes = cx(_defineProperty({
        SVGInline: true,
        "SVGInline--cleaned": cleanup.length
      }, className, className));
      var svgClasses = classes.split(" ").join(classSuffix + " ") + classSuffix;
      var svgStr = SVGInline.cleanupSvg(svg, cleanup).replace(/<svg/, "<svg class=\"".concat(svgClasses, "\"") + (fill ? " fill=\"".concat(fill, "\"") : "") + (width || height ? ' style="' + (width ? "width: ".concat(width, ";") : "") + (height ? "height: ".concat(height, ";") : "") + '"' : ""));
      var match;

      if (accessibilityDesc) {
        match = /<svg(.|\n|\r\n)*?>/.exec(svgStr);
        var pos = match.index + match[0].length;
        svgStr = svgStr.substr(0, pos) + "<desc>".concat(accessibilityDesc, "</desc>") + svgStr.substr(pos);
      }

      if (accessibilityLabel) {
        match = match || /<svg(.|\n|\r\n)*?>/.exec(svgStr);

        var _pos = match.index + match[0].length - 1;

        var id = "SVGInline-".concat(SVGInline.idCount++, "-title");
        svgStr = svgStr.substr(0, _pos) + " role=\"img\" aria-labelledby=\"".concat(id, "\"") + svgStr.substr(_pos, 1) + "<title id=\"".concat(id, "\">").concat(accessibilityLabel, "</title>") + svgStr.substr(_pos + 1);
      }

      return React.createElement(component, _objectSpread({}, componentProps, {
        // take most props
        className: classes,
        dangerouslySetInnerHTML: {
          __html: svgStr
        }
      }));
    }
  }]);

  return SVGInline;
}(Component);

SVGInline.propTypes = {
  className: PropTypes.string,
  classSuffix: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  svg: PropTypes.string.isRequired,
  fill: PropTypes.string,
  cleanup: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  cleanupExceptions: PropTypes.array,
  width: PropTypes.string,
  height: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  accessibilityDesc: PropTypes.string
};
SVGInline.defaultProps = {
  component: "span",
  classSuffix: "-svg",
  cleanup: [],
  cleanupExceptions: []
};
SVGInline.idCount = 0;

SVGInline.cleanupSvg = function (svg) {
  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(cleanups).filter(function (key) {
    return cleanup.indexOf(key) > -1;
  }).reduce(function (acc, key) {
    return acc.replace(cleanups[key], "");
  }, svg).trim();
};

export default SVGInline;